import { useContext } from 'react';
import { useStore } from 'zustand';

import { PageContext } from '../../context/entity-page-context/entity-page-context';
import type { EntityPageStore } from '../../types/entity-page-store';

export const useEntityPageStore = <T>(
  selector: (store: EntityPageStore) => T
): T => {
  const context = useContext(PageContext);

  if (!context) {
    throw new Error('No host context found. Please setup the PageContext');
  }

  return useStore(context, selector);
};
